import $ from 'jquery';

export default function ReadMore($element, readMoreLabel, readLessLabel, ellipsis) {
    let originalContent = $element.html(),
        originalText = $element.text(),
        limitedText = originalText.substring(0, 150),
        // removes trailing hyphen, comma, period and whitespace and adds ellipsis
        limitedTextClean = limitedText.replace(/(-|,|\.|\s)$/g, "") + ellipsis,
        truncatedContent = '<p>'+ limitedTextClean +'</p>',
        readMore = readMoreLabel,
        readLess = readLessLabel;
    
    var toggleRead = function() {
      if(originalText.length > 150) {
        $element.html(truncatedContent);
        var $trigger = $('<a href="#" class="readmoreless readmoreless--more js-readmoreless">'+ readMore + '</a>').insertAfter($element);

        $trigger.on('click', function(event){
          event.preventDefault();
          var $currentTrigger = $(this);
          if($currentTrigger.hasClass('readmoreless--more')) {
            $element.html(originalContent);
            $currentTrigger.removeClass('readmoreless--more').addClass('readmoreless--less').text(readLess);
          } else {
            $element.html(truncatedContent);
            $currentTrigger.removeClass('readmoreless--less').addClass('readmoreless--more').text(readMore);
          }
        });
      }
    };    

    var beforePrint = function() {
        $element.html(originalContent);
        $('.js-readmoreless').detach();
    };
    var afterPrint = function() {
        toggleRead();
    };

    if (window.matchMedia) {
        var mediaQueryList = window.matchMedia('print');
        mediaQueryList.addListener(function(mql) {
            if (mql.matches) {
                beforePrint();
            } else {
                afterPrint();
            }
        });
    }

    window.onbeforeprint = beforePrint;
    window.onafterprint = afterPrint;
    toggleRead();
}